<template>
  <div>
    <div class="speakers">

<!--      <div class="session-content-block__title">Speakers</div>-->
      <c-input
        placeholder="Search Speakers"
        @input="handleFilterChange"
        v-model="searchValue"
      />

      <!--      INDICATOR -->
      <div v-if="isFetching" class="page-loader">
        <c-loader/>
      </div>

      <!--       EMPTY LIST -->
      <div v-else-if="!isFetching && !speakers?.length && !errorStatus">
        <c-list-empty
          style="margin-top: 50px;"
          title="The list is empty"
          description="This page does't have any speakers yet"
        ></c-list-empty>
      </div>

      <!--       ERROR -->
      <div v-else-if="!isFetching && errorStatus">
        <ErrorPage :status="errorStatus"/>
      </div>
      <!--    Filter used -->
      <div v-else-if="!isFetching && !filteredSpeakers?.length && searchValue">
        <c-list-empty
          style="margin-top: 50px;"
          title="The list is empty"
          :description='`Could not find a speaker "${searchValue}"`'
        ></c-list-empty>
      </div>

      <!--       DATA -->
      <div v-else>
        <ul class="speakers-list">
          <li
            class="speakers-list__item"
            v-for="(speaker, index) in visibleSpeakers"
            :key="`speaker-${index}`"
          >
            <speaker-item
              :name="speaker.name"
              :title="speaker.title"
              :description="speaker.bio"
              :photo="speaker.photo"
              :sessions="speaker.sessions"
            />
          </li>
        </ul>

        <div
          v-if="visibleSpeakersCount < filteredSpeakers.length"
          class="load-more-trigger"
          v-observe-visibility="handleVisibilityChange"
        >
          <c-button
            fill
            uppercase
            theme="default"
            icon="fa-solid fa-arrow-down"
            size="sm"
            :show-indicator="true"
            @click="loadMore"
          >
            Load More ...
          </c-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Container from "../../components/ui/Container";
import ColoredStatus from "../../components/ui/ColoredStatus";
import MarkedStatus from "../../components/ui/MarkedStatus";
import SpeakerItem from "./speaker-item";
import common from "../../helpers/common";
import Notify from "../../components/ui/Notify";
import ErrorPage from "../error-page";

let timer;

export default {
  components: {
    Container,
    ColoredStatus,
    MarkedStatus,
    SpeakerItem,
    Notify,
    ErrorPage,
  },
  mounted() {
    common.setHeaderText('Speakers');

    if (!this.hasFetchedSpeakers) {
      this.$store.dispatch("speakersStore/fetchSpeakers", {id: this.attendeeId});
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      searchValue: this.$route.query.search || '',
      localVisibleCount: null,
    };
  },
  watch: {
    '$route'(to, from) {
      if (!to.query.search) {
        this.searchValue = ''
      }
    }
  },
  computed: {
    ...mapGetters('speakersStore', [
      'speakers',
      'isFetching',
      'errorStatus',
      'hasFetchedSpeakers',
      'defaultSpeakersCount',
    ]),

    filteredSpeakers() {
      if (!this.searchValue || !this.searchValue.trim()) {
        return this.speakers;
      }

      const searchLower = this.searchValue.toLowerCase().trim();

      return this.speakers.filter(speaker => {
        const name = (speaker.name || '').toLowerCase();
        return name.includes(searchLower);
      });
    },

    visibleSpeakersCount() {
      return this.localVisibleCount || this.defaultSpeakersCount;
    },

    visibleSpeakers() {
      return this.filteredSpeakers.slice(0, this.visibleSpeakersCount);
    },
  },
  methods: {
    handleVisibilityChange(isVisible) {
      if (isVisible) {
        this.loadMore();
      }
    },

    handleFilterChange() {
      clearTimeout(timer);

      timer = setTimeout(() => {
        // this.$router.push({query: {search: this.searchValue}});
        this.localVisibleCount = this.defaultSpeakersCount;
      }, 700);
    },

    loadMore() {
      const newCount = Math.min(
        this.visibleSpeakersCount + this.defaultSpeakersCount,
        this.filteredSpeakers.length
      );

      this.localVisibleCount = newCount;
    }
  }
};
</script>

<style lang="scss" scoped>
.speakers {
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  padding: var(--attendee-gap-md);

}

.speakers-list {
  &__item {
    max-width: var(--attendee-container-width);
    margin-top: 30px;

    @media (max-width: 900px) {
      margin-top: 20px;
    }
  }
}

.load-more-trigger {
  text-align: center;
  height: 1px;
}
</style>
